import classnames from 'classnames'

import { Alert, AlertProps, Button, IconHome } from '@/components'

type WelcomeAlertProps = AlertProps

export const WelcomeAlert = ({
    className,
    ...props
}: WelcomeAlertProps) =>
    <Alert
        type="custom"
        className={classnames(className, 'bg-orange-400 font-body')}
        icon={<div className="bg-orange-100 flex items-center justify-center p-3 rounded-lg">
            <IconHome className="stroke-orange-600" size="lg"/>
        </div>}
        {...props}
    >
        <div className="flex gap-2 flex-col lg:flex-row items-start lg:items-center justify-between grow">
            <p className="leading-6 ml-4">
                Welcome to the Solar Insure Web Platform! To finish Certification and start
                enrolling <br/>Solar Insure warranties, <span className="font-semibold">Add Your Monitoring
                        Credentials</span></p>

            <Button design="btn-secondary-gray" href="/profile/integrations">
                Add Your Credentials
            </Button>
        </div>
    </Alert>
